import styled from "styled-components";

import { typographyWeights } from "../constants/fontWeightOptions";
import { baseTextStyles } from "../shared/styled";

export const SecondaryMediumBase = styled.h5`
  ${baseTextStyles}
  font-size: 18px;
  font-weight: ${props => typographyWeights[props.weight]};
  line-height: 26px;
`;
